import React, { useEffect, useState } from 'react';
// @mui
import { Box, Button, MenuItem, Stack, Typography } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// components
import Image from '../../../components/Image';
import MenuPopover from '../../../components/MenuPopover';
import { useSelector } from '../../../redux/store';
import { updateHeaders } from '../../../utils/connection-assistant';
import useResponsive from '../../../hooks/useResponsive';
import Iconify from '../../../components/Iconify';
import CustomModal from '../../../components/CustomModal';

// ----------------------------------------------------------------------

export default function LanguagePopover({ sx = {}, CustomBtn, PopoverProps = {} }) {
  const { allLangs, currentLang, onChangeLang, translate } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);

  const [customLangs, setCustomLangs] = useState([]);

  const [open, setOpen] = useState(null);

  const [selectedLang, setSelectedLang] = useState(currentLang);

  const domainLocale = process.env.REACT_APP_LOCALE;

  const langStorage = localStorage.getItem('i18nextLng');

  useEffect(() => {
    // setCustomLangs(allLangs.filter((f) => f.value === 'en' || f.value === domainLocale));
    if (siteSettings?.languages?.length > 0) {
      const matchingLangs = allLangs;
      // I JUST COMMENT THIS TEMPORARILY
      // .filter((obj1) =>
      //   siteSettings?.languages.some((obj2) => obj1.value === obj2.locale)
      // );
      if (matchingLangs) {
        setCustomLangs(matchingLangs);

        if (matchingLangs.findIndex((ml) => ml.value === langStorage) === -1) {
          handleChangeLang(matchingLangs.find((f) => f.value === domainLocale)?.value);
          console.log('matching');
        }
      } else {
        console.log('No Matching languages');
      }
    }
  }, [siteSettings?.languages]);

  // useEffect(() => {
  //   const queryString = window.location.search;

  //   const urlParams = new URLSearchParams(queryString);

  //   setParamLang((prev) => {
  //     if (!prev) {
  //       return urlParams.get('lang');
  //     }
  //     return '';
  //   });
  // }, []);

  // useEffect(() => {
  //   if (customLangs?.length && paramLang) {
  //     const isExist = customLangs.find((x) => x.value === paramLang.toLowerCase());

  //     if (isExist) {
  //       handleChangeLang(isExist?.value);
  //       setParamLang('');
  //     }
  //   }
  // }, [customLangs, paramLang]);

  useEffect(() => {
    console.log(currentLang);
  }, [currentLang]);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleChangeLang = (newLang) => {
    localStorage.setItem('i18nextLng', newLang);
    onChangeLang(newLang);
    handleClose();
    // updateHeaders({ 'X-Language': newLang });
    window.location.reload();
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={(e) => handleOpen(e)}>
        <Box sx={{ flex: 1 }}>
          {CustomBtn ? (
            React.cloneElement(CustomBtn, { title: currentLang?.label })
          ) : (
            <Button
              variant={'text'}
              // onClick={handleOpen}
              startIcon={
                <Image
                  disabledEffect
                  src={currentLang?.icon}
                  alt={currentLang?.label}
                  sx={{ width: 28, maxHeight: '20px', img: { objectFit: 'contain' } }}
                />
              }
              sx={sx}
              size="small"
            >
              <Typography sx={{ color: '#f5b007' }} fontWeight={700}>
                {currentLang.value?.toUpperCase()}
              </Typography>
            </Button>
          )}
        </Box>
        <Iconify icon={'iconamoon:arrow-down-2-fill'} sx={{ color: '#000' }} />
      </Box>

      {/* <MenuPopover */}
      <CustomModal
        open={Boolean(open)}
        onClose={handleClose}
        maxWidth={'xs'}
        paperPropsSx={{
          '& .MuiMenuItem-root': { px: 3, typography: 'body2', borderRadius: 0.75, color: '#000' },
        }}
        title={<Typography sx={{ color: '#000', fontWeight: 900 }}>{translate('please_select_lang')}</Typography>}
      >
        <Stack spacing={0.75} sx={{ py: 1 }}>
          {customLangs.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === currentLang?.value}
              onClick={() => {
                handleChangeLang(option.value);
                setSelectedLang(option);
              }}
            >
              <Image
                disabledEffect
                alt={option.label}
                src={option.icon}
                sx={{
                  width: 28,
                  height: 20,
                  mr: 2,
                  img: {
                    objectFit: 'contain',
                  },
                }}
              />

              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </CustomModal>
    </>
  );
}
